module.exports = __webpack_public_path__ + "img/aclarion.39b034f9.png";